import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ParseOptions } from 'query-string';

import { parseQueryString } from '~utils/router';

export const useParseLocationQuery = <T>(options?: ParseOptions): T => {
  const { search } = useLocation();

  const parseLocationQuery = useMemo(
    () => parseQueryString<T>(search, options),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search],
  );

  return parseLocationQuery;
};
